import { inject, Injectable } from '@angular/core';
import { EntityListStore } from '@webapp/core/stores/entity-list-store.service';
import { PaginationParams } from '@webapp/core/ui/components/pagination/pagination.interfaces';
import { firstValueFrom, map } from 'rxjs';
import { getBadgeAndActions } from '../common/map';
import { IQuoteRow } from '../interfaces/quotes.interface';
import { QuotesService } from '../services/quotes.service';

@Injectable({
	providedIn: 'root',
})
export class UserQuotesStoreService {
	private readonly service = inject(QuotesService);
	public listStore: EntityListStore<IQuoteRow>;

	constructor() {
		this.listStore = new EntityListStore<IQuoteRow>(
			(params: PaginationParams) =>
				firstValueFrom(
					this.service.getQuotes(params).pipe(
						map(row => ({
							...row,
							data: row.data.map(quote => ({
								...quote,
								...getBadgeAndActions(quote),
							})),
						}))
					)
				)
		);
	}

	public getRows() {
		return this.listStore.select('rows');
	}
}
